module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    staticClass: "businesskit-modal",
    attrs: {
      "title": _vm.$t('ui.segments.add_to_project_modal.title'),
      "open": _vm.addToProjectModalOpen,
      "saveText": _vm.$t('ui.segments.add_to_project_modal.add_button'),
      "saveDisabled": !_vm.project.id
    },
    on: {
      "save": function($event) {
        return _vm.addToProject()
      },
      "cancel": function($event) {
        return _vm.closeAddToProjectModalOpen()
      }
    }
  }, [(_vm.projects.length > 0) ? _c('div', [_c('auto-complete', {
    staticClass: "add_to_project-autocomplete",
    attrs: {
      "model": "organization-projects",
      "type": "text",
      "label": "empty",
      "name": "value",
      "item": _vm.project,
      "init": "none",
      "autofocus": true,
      "placeholder": _vm.$t('ui.segments.add_to_project_modal.search_label')
    },
    on: {
      "change": _vm.selectProject
    }
  })], 1) : _c('div', [_vm._v("\n      " + _vm._s(_vm.$t('ui.segments.add_to_project.empty')) + "\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1063bbc6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/Segments/AddToProjectModal.vue
// module id = 1817
// module chunks = 0